import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Flex } from "sprout-ui-primitives";
import styled from "styled-components";
import { CheckOutlined } from "sprout-ui-icons";
const StyledCheckOutlined = styled(CheckOutlined)`
  width: 18px;
  height: 18px;
`;
const TopicPageViewsTopicDividerEditorColorWrapper = styled("label")`
  cursor: pointer;

  input {
    display: none;
  }
`;
const TopicPageViewsTopicDividerEditorColor = (props)=>{
    const { colorHex , value , checked , onChange  } = props;
    const handleChange = ()=>{
        onChange(value);
    };
    return /*#__PURE__*/ _jsxs(TopicPageViewsTopicDividerEditorColorWrapper, {
        children: [
            /*#__PURE__*/ _jsx("input", {
                type: "radio",
                name: "color",
                value: value,
                checked: checked,
                onChange: handleChange
            }),
            /*#__PURE__*/ _jsx(Flex, {
                alignItems: "center",
                justifyContent: "center",
                width: "24px",
                height: "24px",
                borderRadius: "50%",
                bg: colorHex,
                color: "white.100",
                children: checked && /*#__PURE__*/ _jsx(StyledCheckOutlined, {})
            })
        ]
    });
};
export default TopicPageViewsTopicDividerEditorColor;
